<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="header-left">
        <h3>Invite a Mate</h3>
      </div>
      <app-exit-button ariaLabel="Close invite a mate" (clicked)="onClose()"></app-exit-button>
    </div>

    <!-- Private trip: ride-along unavailable -->
    <div class="modal-body" *ngIf="!isRideAlongTrip">
      <div class="ram-empty">
        Ride Along is only available for <strong>Public</strong> or <strong>Dockmates</strong> trips.
        Change this trip's visibility to invite mates.
      </div>
    </div>

    <ng-container *ngIf="isRideAlongTrip">
      <!-- Tabs -->
      <div class="ram-tabs">
        <button class="ram-tab" [class.active]="tab === 'find'" (click)="setTab('find')">Find</button>
        <button class="ram-tab" [class.active]="tab === 'sent'" (click)="setTab('sent')">Sent</button>
        <button class="ram-tab" [class.active]="tab === 'on_trip'" (click)="setTab('on_trip')">On Trip</button>
      </div>

      <!-- Search (Find tab only) -->
      <div class="ram-search" *ngIf="tab === 'find'">
        <input type="text" placeholder="Search dockmates…" [ngModel]="search"
          (ngModelChange)="onSearchChange($event)" />
      </div>

      <div class="modal-body ram-list">
        <div class="ram-loading" *ngIf="loading">Loading…</div>

        <div class="ram-empty" *ngIf="!loading && rows.length === 0">
          <ng-container [ngSwitch]="tab">
            <span *ngSwitchCase="'find'">No dockmates found.</span>
            <span *ngSwitchCase="'sent'">No pending invitations.</span>
            <span *ngSwitchCase="'on_trip'">No one is riding along yet.</span>
          </ng-container>
        </div>

        <div class="ram-row" *ngFor="let row of rows">
          <div class="ram-avatar">
            <img *ngIf="row.imageUrl" [src]="row.imageUrl" alt="" />
            <span *ngIf="!row.imageUrl">{{ initial(row.displayName) }}</span>
          </div>
          <div class="ram-info">
            <div class="ram-name">{{ row.displayName || 'Unknown' }}</div>
            <div class="ram-sub" *ngIf="row.vesselName">{{ row.vesselName }}</div>
          </div>

          <!-- Find tab actions -->
          <ng-container *ngIf="tab === 'find'">
            <span class="ram-chip participant" *ngIf="row.inviteStatus === 'participant'">On trip</span>
            <span class="ram-chip invited" *ngIf="row.inviteStatus === 'invited'">Invited</span>
            <button class="ram-btn invite" *ngIf="row.inviteStatus === 'none'"
              [disabled]="busyIds.has(row.keycloakId)" (click)="invite(row)">Invite</button>
          </ng-container>

          <!-- Sent tab actions -->
          <button class="ram-btn cancel" *ngIf="tab === 'sent'"
            [disabled]="!!row.requestId && busyIds.has(row.requestId)" (click)="cancel(row)">Cancel</button>

          <!-- On Trip tab actions -->
          <button class="ram-btn remove" *ngIf="tab === 'on_trip'"
            [disabled]="busyIds.has(row.keycloakId)" (click)="remove(row)">Remove</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
